// Fuente ÚNICA (2026-09-23, prompt "vista Categorías" — "la función que decide todo esto... vive
// en UN solo lugar y se exporta") de tres decisiones que gobiernan cualquier pantalla que trate
// `clientes` como EMPRESAS en vez de filas-marca:
//   1. Cómo se normaliza el nombre de una empresa para agruparla (trim + mayúsculas + sin tildes).
//   2. Cómo se agrupan las filas de `clientes` (granuladas por marca — 587 filas de Chile son
//      solo 411 empresas distintas, ~30% de inflación si se cuentan filas — ver
//      docs/decisiones/2026-09-23-categorias-empresa-clave-medicion.md) en empresas reales.
//   3. Qué es ACTIVADO / VINCULADO / SIN CONTACTO para una empresa.
// Nace en la vista Categorías (src/pages/Ventas/Categorias/); Mapa de Calor la va a consumir
// después — si cada pantalla arma su propio criterio, un día van a decir cosas distintas del
// mismo cliente (10.1).

export const ESTADO_CONTACTO = {
  ACTIVADO: "activado",
  VINCULADO: "vinculado",
  SIN_CONTACTO: "sin_contacto",
};

/**
 * Normaliza un nombre de empresa para agrupación: trim, mayúsculas, sin tildes. MISMA
 * normalización usada por la tabla `empresas_vip` (pais, empresa_norm) — ver migración
 * 20260923c_crear_empresas_vip.sql.
 * @param {string} empresa
 * @returns {string}
 */
export const normalizarEmpresa = (empresa) => (empresa || "").trim().toUpperCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

/**
 * Agrupa filas de `clientes` (granuladas por marca) por empresa normalizada. La UNIDAD real es
 * la empresa, nunca la fila de `clientes`.
 * @param {Array<{id: number, empresa: string}>} clientes
 * @returns {Map<string, {empresaNorm: string, empresaDisplay: string, clienteIds: number[]}>}
 */
export const agruparClientesPorEmpresa = (clientes) => {
  const grupos = new Map();
  (clientes || []).forEach((c) => {
    if (!c.empresa || !c.empresa.trim()) return;
    const empresaNorm = normalizarEmpresa(c.empresa);
    if (!grupos.has(empresaNorm)) {
      grupos.set(empresaNorm, { empresaNorm, empresaDisplay: c.empresa.trim(), clienteIds: [] });
    }
    grupos.get(empresaNorm).clienteIds.push(c.id);
  });
  return grupos;
};

/**
 * Determina el estado de contacto de una empresa. ACTIVADO gana sobre VINCULADO — una empresa con
 * venta cerrada en el período nunca aparece como "solo vinculada" aunque también tenga actividad
 * de CRM reciente.
 * @param {{tieneVentaCerradaEnPeriodo: boolean, tieneActividadReciente: boolean}} args
 * @returns {string} uno de ESTADO_CONTACTO
 */
export const determinarEstadoContacto = ({ tieneVentaCerradaEnPeriodo, tieneActividadReciente }) => {
  if (tieneVentaCerradaEnPeriodo) return ESTADO_CONTACTO.ACTIVADO;
  if (tieneActividadReciente) return ESTADO_CONTACTO.VINCULADO;
  return ESTADO_CONTACTO.SIN_CONTACTO;
};
